<template>
  <li
    v-bind:class="{ active: sidebarActiveButton === 'steps' }"
    @click="sidebarChangePanel('steps');sidebarChangeActiveButton('steps');canvasChangeView('steps')"
    :title="$t('general.labels.steps')">
    <i class="kp-panel-question"></i>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    sidebarActiveButton: 'sidebarActiveButton',
  }),
  methods: mapActions([
    'sidebarChangePanel',
    'sidebarChangeActiveButton',
    'canvasChangeView',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Steps.vue?2dbc4878
 **/